import { FC, useEffect, useState } from 'react';
import isEmpty from 'lodash/isEmpty';
import map from 'lodash/map';
import Item from 'antd/lib/form/FormItem';
import Col from 'antd/lib/grid/col';
import Row from 'antd/lib/grid/row';
import Select from 'antd/lib/select';

import Catalog from 'api/classes/Catalog';
import sendNotification, { ENotificationTypes } from 'utils/sendNotification';
import { formRules, notFoundContent } from 'utils/constants/constants';
import { EPaymentsFields } from 'types/settings/enums';
import { IBankCountry } from 'types/settings/interfaces';

const { Option } = Select;

const PaymentsCountry: FC = () => {
  const [countries, setCountries] = useState<IBankCountry[]>([]);

  const getCountries = async() => {
    const { success, data, error }: any = await Catalog.getCatalog({ catalog: 'country' });

    if (success) {
      setCountries(data);
    } else {
      sendNotification(ENotificationTypes.Error, error);
    }
  };

  useEffect(() => {
    getCountries();
  }, []);

  return (
    <>
      <h4 className="mb-5">Country</h4>
      <Row gutter={20}>
        <Col span={12}>
          <Item label="Bank Country" name={EPaymentsFields.CountryId} rules={[formRules.required]}>
            <Select
              size="large"
              showSearch
              loading={isEmpty(countries)}
              optionFilterProp="children"
              notFoundContent={notFoundContent}
              placeholder="Enter Bank Country"
            >
              {map(countries, ({ id, name }) => <Option key={id} value={id}>{name}</Option>)}
            </Select>
          </Item>
        </Col>
      </Row>
    </>
  );
};

export default PaymentsCountry;
